import React, { useRef } from 'react';

import amplitude from 'amplitude-js';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import { PLUS_PROMO_BANNER_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_PLUS_MAIN_PAGE } from 'apps/auth/constants/UrlConstants';
import { fetchData } from 'apps/auth/helpers/api';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { showPromoModal } from 'apps/auth/services/promoModalService';

import PaysendPlusStories from './PaysendPlusStories';
import { BannerCloseButton, BannerContainer, BannerSubtitle } from './styles';

const PaysendPlusBanner = (props) => {
    const { ballId } = useAuth();
    const { paysendPlusBannerTitle, paysendPlusBannerText } = usePageMessages();
    const { showPlusPromoSliders, plusPromoSliders } = useExtra();
    const popupFullwidthRef = useRef(null);

    const onClose = (e) => {
        e.stopPropagation();
        props.updateExtraByName('paysendPlusBannerEnabled', false);
        fetchData('/auth/plus/hide/banner');
    };

    const closePaysendPlusStories = () => {
        popupFullwidthRef?.current?.close();
    };

    const onBannerClick = () => {
        amplitude.getInstance().logEvent(PLUS_PROMO_BANNER_CLICKED);
        if (showPlusPromoSliders) {
            const showModal = showPromoModal(ballId, plusPromoSliders, 'paysend_plus_promo_info');
            if (showModal) {
                popupFullwidthRef?.current?.open(<PaysendPlusStories closeModal={closePaysendPlusStories} />);
            }
        }
    };

    return (
        <>
            <BannerContainer href={!showPlusPromoSliders ? AUTH_PLUS_MAIN_PAGE : null} onClick={onBannerClick}>
                <BannerCloseButton>
                    <DiskButton size="small" iconName="cross" iconColor="white_base" type="button" variant="glass" onClick={onClose} />
                </BannerCloseButton>
                <div>
                    <Text variant="div" color="white_base" indent="8px" size="main">
                        {paysendPlusBannerTitle}
                    </Text>
                    <BannerSubtitle>
                        <Text variant="div" color="white_base" size="secondary" indent="16px">
                            {paysendPlusBannerText}
                        </Text>
                    </BannerSubtitle>
                </div>
                <Icon name="transfers-thin" size="64px" color="white_base" leftIndent="8px" />
            </BannerContainer>
            <PopupNew ref={popupFullwidthRef} fullwidthPopup />
        </>
    );
};
export default PaysendPlusBanner;
